import { IUiDataService } from '@src/slide/domain/ui-model/service/ui-data-service.interface';
import {
    IThemeModel,
    IThemeSelectItem,
} from '@src/slide/domain/ui-model/element-modeles/Interface/theme-model.interface';
import {
    SlideContentEnumeratorService,
} from '@src/slide/application/service/slide-content-enumerator/slide-content-enumerator-service';
import {
    ISlideContentEnumeratorService,
} from '@src/slide/application/service/slide-content-enumerator/slide-content-enumerator-service.interface';
import { IThemeColorDialogProps } from '@src/slide/application/service/theme-color-manager/theme-color-dialog';
import { IPresentationStoreService } from '@src/slide/domain/slide-app/core/interfaces/presentation-service.interface';
import { ITDColor } from '@src/slide/domain/ui-model/element-modeles/property/color/td-color';
import { IShapeModel } from '@src/slide/domain/ui-model/element-modeles/Interface/shape-model.interface';

export interface IThemeColorInfo {
    val?: number;
    lum?: ILumInfo;
}

export interface ILumInfo {
    lumMod?: number;
    lumOff?: number;
}

// 点击来源
export enum EShowModalSource {
    toolbar = 1,
    rightMenu = 2,
    ai = 3,
    tips = 4,
}

export interface IConvertOptions {
    ignorePlaceholder?: boolean;
    fontColor?: ITDColor;
}

export interface IShowThemeModalProps {
    source: EShowModalSource;
    showCustomTab?: boolean;
    onSelect?(themeId: string);
    onCancel?();
}

export interface IThemeColorManager {
    cloneUiDataService: IUiDataService | null;
    themeColorDialogVisible: boolean;
    themeColorCustomDialogVisible: boolean;
    currentThemeModel?: IThemeModel;
    currentEditThemeKey?: string;
    newPresentationStoreService: IPresentationStoreService;
    customColorList: Array<IThemeSelectItem>;
    isOpenCustomPanel: boolean;
    /**
     * ai扩展 - 选择主题后的回调
     * @param themeId
     */
    onSelect?(themeId: string): void;
    /**
     * ai扩展 - 关闭弹窗后的回调
     * @param themeId
     */
    onCancel?(): void;
    /**
     * 设置枚举服务依赖
     * @param slideContentEnumeratorService
     */
    setSlideContentEnumeratorService(slideContentEnumeratorService: ISlideContentEnumeratorService): void;
    /**
     * 设置撤销重做事件回掉
     * @param callback
     */
    addUndoEventCallBack(callback: (canUndo: boolean) => void): void;

    /**
     * 销毁复制的slideApp/uiService
     */
    destroyCopySlideApp(): void;
    // openThemeColorDialog(): void;

    /**
     * 更新主题对话框弹出状态
     * @param visible
     */
    updateThemeColorDialogVisible(visible: boolean): void;

    /**
     * 更新自定义主题对话框弹出状态
     * @param visible
     */
    updateThemeColorCustomDialogVisible(visible: boolean): void;

    /**
     * 根据id切换主题
     * @param id
     */
    applyThemeColor(id: string): void;

    /**
     * 打开主题弹窗
     * @param props
     */
    showThemeModal(props?: IShowThemeModalProps);

    /**
     * 打开主题切换引导
     */
    showThemeTips();

    /**
     * 自定义色映射主题
     * @param isPreview
     */
    convertCustomColorToTheme(isPreview: boolean, options?: IConvertOptions);

    /**
     * 刷新主题
     */
    updateCurrentThemeModel();

    /**
     * 根据id获取自定义主题
     */
    getCustomThemeById(themeId: string): IThemeSelectItem | undefined;

    /**
     * 获取所有自定义主题
     */
    getAllCustomTheme(): Array<IThemeSelectItem>;

    /**
     * 更新主题
     */
    updateCustomTheme(props: IThemeSelectItem): void;

    /**
     * 根据id删除主题
     */
    removeCustomThemeById(themeId: string): void;
    removeCustomThemeByCurrentEditKey(): void;
    setCurrentEditKey(themeKey): void;

    /**
     * 新增主题
     */
    addCustomTheme(props: IThemeSelectItem): IThemeSelectItem;

    /**
     * 获取ui
     */
    getLazyComponent(props: Omit<IThemeColorDialogProps, 'themeColorManager'>): React.ReactElement;

    /**
     * 文本颜色主题化
     * 将每一个textRun的颜色在主题色彩空间中做一次模糊匹配
     * @param shapeModel
     * @param convertOption
     */
    handleTextColorToTheme(shapeModel: IShapeModel, convertOption?: IConvertOptions);
}
